import { ButtonGroup } from "../../../components/core/basic/ButtonGroup";
import Card from "../../../components/core/basic/Card";
import { useState } from "react";
import { Flex, VStack } from "../../../../styled-system/jsx";
import Loading from "../../../components/core/blocks/Loading";
import { ProductImageURL } from "../../../components/custom/category/listings/ProductImage";
import { Link } from "@tanstack/react-router";
import { cut } from "../../../utils/formatText";
import ExternalProductLink from "../../../components/custom/merchandise/ExternalProductLink";
import { css } from "../../../../styled-system/css";
import { useLiveDashboardFilters } from "../api/useLiveDashboardFilters";
import { useLiveOrders } from "../api/useLiveOrders";
import { type GVProduct } from "../../../zodios/common/gvProductSchema";
import { useTranslation } from "react-i18next";

interface ProductListProps {
  accessor: "products" | "top_products";
}
const ProductList = ({ accessor }: ProductListProps) => {
  const filters = useLiveDashboardFilters();
  const liveOrdersQuery = useLiveOrders(filters);

  const productsToRender = liveOrdersQuery.isLoading || !liveOrdersQuery.data ? [] : liveOrdersQuery.data[accessor];

  return (
    <div>
      {liveOrdersQuery.isLoading ?
        <Loading fullPage={false} height={"400px"} />
      : productsToRender.map((product: GVProduct) => {
          return (
            <div key={product.id} className={css({ paddingY: "small" })}>
              <Flex alignItems={"center"}>
                <ProductImageURL url={product.product_image_url} width="50px" height="50px" />
                <VStack
                  css={{
                    gap: 0,
                    alignItems: "flex-start",
                    maxWidth: "100%",
                    marginLeft: "medium",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                  }}
                >
                  <Link
                    style={{
                      textDecoration: "none",
                      fontWeight: 500,
                      fontSize: "1.5rem",
                      cursor: "pointer",
                    }}
                    to="/user/merchandising/product/$product"
                    params={{ product: String(product.id) }}
                    target="_blank"
                  >
                    {cut(product.product_title, 100)}
                  </Link>
                  <small>
                    {product.sku} - {product.asin} <ExternalProductLink asin={product.asin.toUpperCase()} />
                  </small>
                </VStack>
                {accessor === "top_products" && (
                  <span className={css({ paddingX: "xlarge", fontSize: "large" })}>
                    {liveOrdersQuery.data?.top_units_sold[product.id]}
                  </span>
                )}
              </Flex>
            </div>
          );
        })
      }
    </div>
  );
};

const TodaysProductsSummary = () => {
  const { t } = useTranslation(["live"]);
  const [selectedProductBucket, setSelectedProductBucket] = useState("top_5_products_sold_today");

  return (
    <Card>
      <Flex justifyContent={"center"}>
        <ButtonGroup
          buttons={[
            {
              label: t(($) => $.live["Top 5 Products Sold Today"]),
              value: "top_5_products_sold_today",
            },
            {
              label: t(($) => $.live["Last 5 Products Sold"]),
              value: "last_5_products_sold",
            },
          ]}
          value={selectedProductBucket}
          onSelect={(value) => {
            setSelectedProductBucket(value);
          }}
        />
      </Flex>
      {selectedProductBucket === "last_5_products_sold" && <ProductList accessor={"products"} />}
      {selectedProductBucket === "top_5_products_sold_today" && <ProductList accessor={"top_products"} />}
    </Card>
  );
};

export default TodaysProductsSummary;
